<template>
  <div class="card p-fluid">
    <div class="formgrid grid">
      <SelectButton
        titulo="Unidade"
        :options="unidades"
        :ativo="formInteresse.Unidade.codigo"
        v-model="formInteresse.Unidade"
        @update:modelValue="selecaoUnidade()" />
      <SelectButton
        v-if="exibirPeriodo"
        titulo="Período"
        :options="periodos"
        :ativo="formInteresse.Periodo.codigo"
        v-model="formInteresse.Periodo"
        @update:modelValue="selecaoPeriodo()" />
      <SelectButton
        v-if="exibirCurso"
        titulo="Curso"
        :options="cursos"
        :ativo="formInteresse.Curso.codigo"
        v-model="formInteresse.Curso"
        @update:modelValue="selecaoCurso()" />
      <SelectButton
        v-if="exibirSerie"
        titulo="Série"
        :options="seriesCurso"
        :ativo="formInteresse.Serie.codigo"
        v-model="formInteresse.Serie"
        @update:modelValue="selecaoSerie()" />
      <SelectButton
        v-if="exibirTurno"
        titulo="Turno"
        :options="turnosSerie"
        :ativo="formInteresse.Turno.codigo"
        v-model="formInteresse.Turno"
        @update:modelValue="selecaoTurno()" />
    </div>
  </div>
</template>

<script>
import requisicao from "@/services/Requisicoes/Get/configuracaoService";
import { useOpcoesStore } from "@/store/opcoes";
import { storeToRefs } from "pinia";
import SelectButton from "@/components/comuns/SelectButton.vue";

export default {
  setup() {
    const storeOpcoes = useOpcoesStore();
    const { unidades } = storeToRefs(storeOpcoes);
    return {
      unidades
    };
  },

  name: "InteresseComponent",

  components: {
    SelectButton,
  },

  data: () => ({
    exibirPeriodo: false,
    exibirCurso: false,
    exibirSerie: false,
    exibirTurno: false,

    periodos: [],
    cursos: [],
    series: [],
    seriesCurso: [],
    turnos: [],
    turnosSerie: [],

    formInteresse: {
      Unidade: {
        codigo: 0,
        descricao: ''
      },
      Periodo: {
        codigo: 0,
        descricao: ''
      },
      Curso: {
        codigo: 0,
        descricao: ''
      },
      Serie: {
        codigo: 0,
        descricao: ''
      },
      Turno: {
        codigo: 0,
        descricao: ''
      },
      finalizadoOpcaoInteresse: false,
    },
  }),

  methods: {
    enviarEventoFinalizacaoOpcoesInteresse(finalizadoEtapaOpcoesInteresse){
      this.formInteresse.finalizadoOpcaoInteresse = finalizadoEtapaOpcoesInteresse;
      this.$emit('finalizadoInteresse', this.formInteresse);
    },
    
    async selecaoUnidade() {
      try {
        if(this.formInteresse.Unidade.codigo === 0)
          return
        
        this.configuracoesInteresse = await requisicao.obterConfiguracaoDetalhada(this.formInteresse.Unidade.codigo)
        await this.preencherInformacoes(this.configuracoesInteresse)                
      } catch {
        //to-do: adicionar mensagem para o usuário
      }                        
    },

    async preencherInformacoes(response) {
      this.periodos = response.configuracaoUnidade.periodos;
      this.cursos = response.configuracaoUnidade.cursos;
      this.series = response.configuracaoUnidade.series;
      this.turnos = response.configuracaoUnidade.turnos;

      this.formInteresse.Periodo = { codigo: 0, descricao: '' };
      this.formInteresse.Curso = { codigo: 0, descricao: '' };
      this.formInteresse.Serie = { codigo: 0, descricao: '' };
      this.formInteresse.Turno = { codigo: 0, descricao: '' };

      this.exibirPeriodo = true;
      this.exibirCurso = false;
      this.exibirSerie = false;
      this.exibirTurno = false;

      this.enviarEventoFinalizacaoOpcoesInteresse(false);
    },

    selecaoPeriodo() {
      if(this.formInteresse.Periodo.codigo === 0)
          return
      
      this.formInteresse.Curso = { codigo: 0, descricao: '' };
      this.formInteresse.Serie = { codigo: 0, descricao: '' };
      this.formInteresse.Turno = { codigo: 0, descricao: '' };

      this.exibirCurso = true;
      this.exibirSerie = false;
      this.exibirTurno = false;

      this.enviarEventoFinalizacaoOpcoesInteresse(false);
    },

    selecaoCurso() {
      if(this.formInteresse.Curso.codigo === 0)
          return
      
      this.seriesCurso = this.series.filter(serie => serie.codigoCurso == this.formInteresse.Curso.codigo);

      this.formInteresse.Serie = { codigo: 0, descricao: '' };
      this.formInteresse.Turno = { codigo: 0, descricao: '' };

      this.exibirSerie = true;
      this.exibirTurno = false;

      this.enviarEventoFinalizacaoOpcoesInteresse(false);
    },

    selecaoSerie() {
      if(this.formInteresse.Serie.codigo === 0)
          return

      this.turnosSerie = this.turnos.filter(turno => turno.codigoSerie == this.formInteresse.Serie.codigo);
      
      this.formInteresse.Turno = { codigo: 0, descricao: '' };
      
      this.exibirTurno = true;

      this.enviarEventoFinalizacaoOpcoesInteresse(false);
    },

    selecaoTurno() {
      this.enviarEventoFinalizacaoOpcoesInteresse(true);
    }
  },
  
  mounted() {
    this.emitter.on('configuracoesIniciaisInteresse', (configuracoesIniciais) => {
        this.unidades = configuracoesIniciais.unidades;
    })
  }
}
</script>